import $ from "jquery";

window.$ = window.jQuery = $;
$( document ).ready(
	function () {
		const $languageToggle = $( '#languageToggle' );

		$languageToggle.on(
			'click touch',
			function () {
				let ariaExpanded = $( this ).attr( 'aria-expanded' );
				$( this ).toggleClass( 'open' );

				if ( ariaExpanded === 'true' ) {
					$( this ).attr( 'aria-expanded', 'false' );
				} else {
					$( this ).attr( 'aria-expanded', 'true' );
				}
			}
		);

		// Capture clicks outside language toggle.
		$( document ).on(
			'click touch',
			function ( event ) {
				let $target   = $( event.target );
				let $selector = $( '.site-header__language-selector' );

				if ( ! $target.closest( '.site-header__language-selector' ).length ) {
					$selector.removeClass( 'open' );
					$selector.attr( 'aria-expanded', 'false' );
				}
			}
		);
	}
);
